export const MEGA_MENU_DROPDOWN_HEIGHT_CLASS = 'h-[460px]';
export const MEGA_MENU_DROPDOWN_PADDING_CLASS = 'px-12 py-8';
export const MEGA_MENU_COLUMN_WIDTH_CLASS = 'w-[318px]';
export const MEGA_MENU_COLUMN_GAP_CLASS = 'gap-6';
/** Cancels `py-8` and extends past `px-12` so a start-column fill can clip at the dropdown edges. */
export const MEGA_MENU_START_COLUMN_BLEED_CLASS = 'pointer-events-none absolute -top-8 -bottom-8 left-[-100vw] right-0';

/** Hide priority from the right: 1 hides first as the viewport narrows. */
export function getMegaMenuColumnHideClass(hidePriority?: number): string | undefined {
    switch (hidePriority) {
        case 1:
            return 'max-[1339px]:hidden';
        case 2:
            return 'max-[977px]:hidden';
        case 3:
            return 'max-[659px]:hidden';
        default:
            return undefined;
    }
}

export function assignHidePrioritiesFromRight<T extends object>(columns: T[]): Array<T & { hidePriority: number }> {
    const visibleCount = columns.length;
    return columns.map((column, index) => ({
        ...column,
        hidePriority: visibleCount - index,
    }));
}
